import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { MsalRedirectComponent } from '@azure/msal-angular';
import { DxAccordionModule, DxButtonModule, DxCheckBoxModule, DxDropDownBoxModule, DxNumberBoxModule, DxPopupModule, DxScrollViewModule, DxSelectBoxModule, DxTextAreaModule, DxTextBoxModule, DxTreeViewModule } from 'devextreme-angular';
import { LoginService, PumpcalcCoreModule, RestDataService } from 'pumpcalc-core';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { BackingPumpFormComponent } from './backing-pump-form/backing-pump-form.component';
import { BoosterDetailComponent } from './booster-detail/booster-detail.component';
import { BoosterFormComponent } from './booster-form/booster-form.component';
import { DiagramComponent } from './diagram/diagram.component';
import { FormSectionService } from './form-section.service';
import { ListDialogueComponent } from './list-dialogue/list-dialogue.component';
import { ObjectDiffService } from './object-diff.service';
import { PumpListService } from './pump-list.service';
import { PumpSetDetailComponent } from './pump-set-detail/pump-set-detail.component';
import { PumpsetBuilderFormComponent } from './pumpset-builder-form/pumpset-builder-form.component';
import { PumpsetDiffService } from './pumpset-diff.service';
import { PumpsetFormComponent } from './pumpset-form/pumpset-form.component';
import { PumpsetListService } from './pumpset-list.service';
import { ShareDialogueComponent } from './share-dialogue/share-dialogue.component';
import { PumpsetSelectionListComponent } from './pumpset-selection-list/pumpset-selection-list.component';

const appRoutes: Routes = [
  // { path: '', component:LoginComponent , pathMatch: 'full'},
  // { path: '**', component:LoginComponent}
];

@NgModule({
  declarations: [
    AppComponent,
    PumpsetBuilderFormComponent,
    BackingPumpFormComponent,
    BoosterFormComponent,
    PumpsetFormComponent,
    DiagramComponent,
    ListDialogueComponent,
    ShareDialogueComponent,
    PumpSetDetailComponent,
    BoosterDetailComponent,
    PumpsetSelectionListComponent
  ],
  imports: [
    BrowserModule,
    PumpcalcCoreModule.forRoot({ app_config: environment }),
    DxPopupModule,
    DxAccordionModule,
    DxButtonModule,
    DxNumberBoxModule,
    DxSelectBoxModule,
    DxDropDownBoxModule,
    DxTreeViewModule,
    DxCheckBoxModule,
    DxTextBoxModule,
    DxTextAreaModule,
    DxTreeViewModule,
    DxScrollViewModule,
    DxPopupModule,
    RouterModule.forRoot(appRoutes),
  ],
  providers: [RestDataService,
              LoginService,
              FormSectionService,
              PumpListService,
              PumpsetListService,
              PumpsetDiffService,
              ObjectDiffService
            ],
  bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule { }
